import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { TranslationLoaderService } from "src/app/core/service/translation-loader.service";
import { locale as english } from "./i18n/en-US";
import { locale as spanish } from "./i18n/es-ES";
import { locale as portuguese } from "./i18n/pt-BR";

@Component({
    selector: "app-terms-of-use-dialog",
    templateUrl: "./terms-of-use-dialog.component.html",
    styleUrls: ["./terms-of-use-dialog.component.scss"]
})
export class TermsOfUseDialogComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any>;

    termsOfUse: string;

    constructor(
        private _translationLoaderService: TranslationLoaderService,
        private _translateService: TranslateService,
        private _httpClient: HttpClient,
        private _apiSubscriptionsService: SubscriptionService
    ) {
        // Load the translations
        this._translationLoaderService.loadTranslations(english, portuguese, spanish);

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.termsOfUse = null;
    }

    ngOnInit(): void {
        const url = this._apiSubscriptionsService.currentSubscription?.settings?.termsOfUseUrl;

        if (!url) {
            this._translateService
                .get("TERMS_OF_USE.DEFAULT")
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((res) => (this.termsOfUse = res));
        }

        this._httpClient
            .get(url, { responseType: "text" })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (response) => (this.termsOfUse = response),
                (err) => {
                    console.log(err);
                    this._translateService
                        .get("TERMS_OF_USE.SUBMIT_ERROR")
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((res) => (this.termsOfUse = res));
                }
            );
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
